module.exports = __webpack_public_path__ + "static/media/boy and girl.c125de8c.jpg";